
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import RevenueSplitChart from '../RevenueSplitChart';

interface RevenueSplit {
  monthlyGross: string;
  siteSplit: string;
  resellerSplit: string;
}

interface RevenueSplitSectionProps {
  revenueSplits: RevenueSplit[];
}

const RevenueSplitSection: React.FC<RevenueSplitSectionProps> = ({ revenueSplits }) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-8">
      <h3 className="text-xl font-semibold mb-4 text-primary-blue">How You Make Money</h3>
      <p className="mb-4">
        When you sell a referral plan to a business, they pay a monthly recurring fee. As your sales volume increases, your revenue share percentage grows.
      </p>
      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <h4 className="text-lg font-medium mb-3">Example Revenue Split</h4>
          <div className="bg-gray-50 p-4 rounded-lg flex flex-col md:flex-row items-center">
            <RevenueSplitChart siteShare={47.20} yourShare={11.80} />
            <div className="mt-4 md:mt-0 md:ml-4">
              <p className="text-primary-blue font-semibold mb-2">For a $59.00 monthly plan:</p>
              <div className="space-y-2">
                <p className="flex items-center">
                  <span className="w-3 h-3 inline-block bg-blue-500 rounded-sm mr-2"></span>
                  <strong>ReferMe.site share:</strong> $47.20 (80%)
                </p>
                <p className="flex items-center">
                  <span className="w-3 h-3 inline-block bg-green-500 rounded-sm mr-2"></span>
                  <strong>Your share:</strong> $11.80 (20%)
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h4 className="text-lg font-medium mb-3">Revenue Share Tiers</h4>
          <Table>
            <TableHeader>
              <TableRow className="bg-gray-50">
                <TableHead>Monthly Gross</TableHead>
                <TableHead>Site %</TableHead>
                <TableHead>Your %</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {revenueSplits.map((split, index) => (
                <TableRow key={index} className={index % 2 === 0 ? "bg-gray-50" : ""}>
                  <TableCell>{split.monthlyGross}</TableCell>
                  <TableCell>{split.siteSplit}</TableCell>
                  <TableCell className="font-medium text-green-600">{split.resellerSplit}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default RevenueSplitSection;
